import React from "react";
import { Slide } from "react-reveal";
import pitconst from "../../assets/images/content/j21.jpg";
import butt from "../../assets/images/update1/butt.jpg";
import water from "../../assets/images/update1/watercontainment.jpeg";
import geo from "../../assets/images/update1/geosynthetic.jpg";
import restor from "../../assets/images/content/e1.jpeg";
import wear from "../../assets/images/content/h1.jpeg";
import insp from "../../assets/images/content/hh1.jpeg";
import waste from "../../assets/images/content/h3.jpeg";
import tnt from "../../assets/images/content/tnt.png";
import HighlightCard from "../reusables/HighlightCard";

const ServicesList = () => {
  return (
    <Slide left>
      <ul className="hightlights-container flex">
        <HighlightCard
          img={geo}
          link="#"
          title="Geosynthetics Installation &amp; Associated earthworks"
        >
          Fusion Welding for HDPE Liner, Extrusion welding for HDPE repairs, Hot
          gas welding for tacking and Reinforced Vinyl Tank Construction,
          Welding and assembling inflatable HDPE tanks
        </HighlightCard>
        <HighlightCard
          img={butt}
          link="#"
          title="HDPE Piping Installation &amp; associated earthworks"
        >
          Butt fusion
        </HighlightCard>
        <HighlightCard
          img={insp}
          link="#"
          title="Destructive &amp; Non-destructive Inspection"
        >
          Shear and peel tests, Air Pressure Testing, Vacuum Air Pressure
          Testing, Air Spark Testing
        </HighlightCard>
        <HighlightCard
          img={restor}
          link="#"
          title="Environmental Restoration Works"
        ></HighlightCard>

        <HighlightCard
          img={waste}
          link="#"
          title="Hazardous waste transportation"
        ></HighlightCard>

        <HighlightCard
          img={wear}
          link="#"
          title="Supply of Industrial Work Wear"
        ></HighlightCard>

        <HighlightCard
          img={water}
          link="#"
          title="Recreational water containment facilities construction"
        ></HighlightCard>

        <HighlightCard
          img={tnt}
          link="#"
          title="Tent/Tarpaulin making &amp; repair"
        ></HighlightCard>
      </ul>
    </Slide>
  );
};

export default ServicesList;
